module.exports = __webpack_public_path__ + "img/134.bf05582d.jpg";